import { render } from "./j-text2.vue?vue&type=template&id=327c4f60&scoped=true&ts=true"
import script from "./j-text2.vue?vue&type=script&lang=ts"
export * from "./j-text2.vue?vue&type=script&lang=ts"

import "./j-text2.vue?vue&type=style&index=0&id=327c4f60&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327c4f60"]])

export default __exports__